module.exports = __webpack_public_path__ + "static/media/part-04.0da81b7d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/gallery/part-04.jpg
// module id = 935
// module chunks = 0